(function () {
  'use strict';

  /* @ngdoc object
   * @name dms.signoff
   * @description
   *
   */
  angular
    .module('dms.signoff', [
      'ui.router'
    ]);
}());
